export default __webpack_public_path__ + "static/breakpoint-setting-do-dark-935b18bf9440b5fc36d5d55858b6a9fb296fa07efd4b08be1ec2361357c6d51b.png";